export const ROUTES = {
  addClient: "add-client",
  addUser: "add-user",
  applies: "applies",
  budgetPlanning: "budget-planning",
  campaigns: "campaigns",
  candidates: "candidates",
  tokenManagement: "token-management",
  changePassword: "/change-password",
  channels: "channels",
  clientDetails: "client-details",
  clients: "clients",
  created: "created",
  createSegment: "/create-segment",
  descriptions: "descriptions",
  edit: "edit",
  forgotPassword: "/forgot-password",
  home: "home",
  insights: "insights",
  integrations: "integrations",
  /** Path segment for campaign integrations (under campaigns). Same as integrations but scoped to campaign context. */
  campaignIntegrations: "integrations",
  invoiceable: "invoiceable",
  invoiced: "invoiced",
  invoices: "invoices",
  jobBoards: "jobboards",
  linkSent: "/link-sent",
  login: "/login",
  managedClients: "/clients/managed-clients",
  new: "new",
  notifications: "notifications",
  recruitNow: "recruitnow",
  reporting: "reporting",
  segments: "segments",
  setPassword: "/set-password",
  settings: "settings",
  signOut: "/sign-out",
  spent: "spent",
  toDo: "to-do",
  transactions: "transactions",
  unmanagedClients: "/clients/unmanaged-clients",
  userCreated: "user-created",
  users: "users",
  vacancies: "vacancies",
  vacancyDescriptions: "descriptions",
  webAnalytics: "web-analytics",
  webhooks: "webhooks",
} as const;
